"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MicrositeWidgetTemplateKeys = void 0;
exports.MicrositeWidgetTemplateKeys = {
    __typename: true,
    id: true,
    type: true,
    translations: false,
    standardRefID: false,
    disclosureRefIDs: false,
    disclosureRefIDString: false,
    unitDataTypeRef: false,
};
//# sourceMappingURL=MicrositeWidgetTemplate.type.js.map